<template>
    <b-modal
        id="m-reset-grade"
        title="Request Reset Grade"
        size="lg"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        @show="resetForm"
    >
        <div class="mb-3">
            No. Faktur: <strong>{{ noFaktur || "-" }}</strong>
            <span class="ml-3">Grade saat ini: <strong>{{ currentGrade || "-" }}</strong></span>
        </div>
        <b-form-group label-class="font-weight-bold">
            <template #label>
                Pilih Grade <span class="text-danger">*</span>
            </template>
            <b-form-select v-model="grade" :options="optGrade" />
        </b-form-group>
        <b-form-group label-class="font-weight-bold">
            <template #label>
                Alasan <span class="text-danger">*</span>
            </template>
            <b-form-textarea v-model="notes" rows="3" maxlength="255" placeholder="Masukkan alasan reset grade" />
            <small class="text-muted">{{ notes.length }} / 255</small>
        </b-form-group>
        <div class="text-right">
            <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('m-reset-grade')">
                Batal
            </b-button>
            <b-button variant="primary" :disabled="isSubmitting" @click="submit">
                {{ isSubmitting ? "Menyimpan..." : "Kirim Request" }}
            </b-button>
        </div>
    </b-modal>
</template>

<script>
const GRADES = ["S", "A", "B", "C", "D", "E", "X"];

export default {
    name: "ModalResetGrade",
    props: {
        inventoryId: { type: Number, default: null },
        noFaktur: { type: String, default: "" },
        currentGrade: { type: String, default: "" }
    },
    data() {
        return {
            grade: null,
            notes: "",
            isSubmitting: false
        };
    },
    computed: {
        optGrade() {
            return [{ value: null, text: "Pilih grade" }].concat(
                GRADES.map(g => ({ value: g, text: g === this.currentGrade ? `${g} (grade saat ini)` : g }))
            );
        }
    },
    methods: {
        resetForm() {
            this.grade = null;
            this.notes = "";
        },

        async submit() {
            if (!this.grade) return this.$helper.toastError(this, "Grade wajib dipilih");
            if (!this.notes.trim()) return this.$helper.toastError(this, "Alasan wajib diisi");
            if (!confirm(`Request reset grade ke ${this.grade} untuk barang ini? Barang akan kembali PENDING setelah di-approve.`)) return;

            this.isSubmitting = true;
            try {
                await this.$axios.post("inventory/request-reset", {
                    id: this.inventoryId,
                    type: "grade",
                    grade: this.grade,
                    notes: this.notes.trim()
                });
                this.$helper.toastSuccess(this, "Request berhasil dikirimkan!");
                this.$bvModal.hide("m-reset-grade");
                this.$emit("saved");
            } catch (error) {
                this.$helper.parseError(this, error);
            } finally {
                this.isSubmitting = false;
            }
        }
    }
};
</script>
